
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 630 360"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#da0000","d":"M0 0h630v360H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h630v240H0z"}}),_c('path',{attrs:{"fill":"#239f40","d":"M0 0h630v120H0z"}}),_c('g',{attrs:{"transform":"translate(8.4 100.4)"}},[_c('g',{attrs:{"id":"e"}},[_c('g',{attrs:{"id":"c","fill":"none","stroke":"#fff","stroke-width":"2"}},[_c('path',{attrs:{"id":"b","d":"M0 1h26M1 10V5h8v4h8V5h-5M4 9h2m20 0h-5V5h8m0-5v9h8V0m-4 0v9","transform":"scale(1.4)"}}),_c('path',{attrs:{"id":"a","d":"M0 7h9m1 0h9","transform":"scale(2.8)"}}),_c('use',{attrs:{"xlink:href":"#a","y":"120"}}),_c('use',{attrs:{"xlink:href":"#b","y":"145.2"}})]),_c('g',{attrs:{"id":"d"}},[_c('use',{attrs:{"xlink:href":"#c","x":"56"}}),_c('use',{attrs:{"xlink:href":"#c","x":"112"}}),_c('use',{attrs:{"xlink:href":"#c","x":"168"}})])]),_c('use',{attrs:{"xlink:href":"#d","x":"168"}}),_c('use',{attrs:{"xlink:href":"#e","x":"392"}})]),_c('g',{attrs:{"fill":"#da0000","transform":"matrix(45 0 0 45 315 180)"}},[_c('g',{attrs:{"id":"f"}},[_c('path',{attrs:{"d":"M-.548.836A.912.912 0 00.329-.722 1 1 0 01-.548.836"}}),_c('path',{attrs:{"d":"M.618.661A.764.764 0 00.422-.74 1 1 0 01.618.661M0 1l-.05-1L0-.787a.31.31 0 00.118.099V-.1l-.04.993zM-.02-.85L0-.831a.144.144 0 00.252-.137A.136.136 0 010-.925"}})]),_c('use',{attrs:{"xlink:href":"#f","transform":"scale(-1 1)"}})])])
          )
        }
      }
    